/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/common/material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExtendedSelectComponent } from './mat-extended-select.component';
import { MatStatusIndicatorComponent } from './mat-status-indicator.component';
import { LegacyFileUploadComponent } from './file-upload.component';
import { TextDisplayContainerComponent } from './text-display-container/text-display-container.component';
import { MatNumberSpinnerComponent } from './mat-number-spinner.component';
import { WorkdaysComponent } from './workdays.component';
import { TitleHeaderComponent } from 'src/app/shared/ui/material/title-header/title-header.component';
import { MatRoleSelectComponent } from './mat-role-select.component';
import { TpFileUploadComponent } from './tp-file-upload.component/tp-file-upload.component';
import { FileUploadCustomSlotDirective } from './tp-file-upload.component/file-upload-custom-slot';
import { FileUploadSinglerDirective } from './tp-file-upload.component/file-upload-singler';
import { CheckboxListModule } from './checkbox-list/checkbox-list.module';
import { WhoYouComponent } from './who-you/who-you.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
	declarations: [
		MatExtendedSelectComponent,
		MatStatusIndicatorComponent,
		LegacyFileUploadComponent,
		TpFileUploadComponent,
		FileUploadSinglerDirective,
		FileUploadCustomSlotDirective,
		TextDisplayContainerComponent,
		MatNumberSpinnerComponent,
		WorkdaysComponent,
		TitleHeaderComponent,
		MatRoleSelectComponent,
		WhoYouComponent,
	],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		CheckboxListModule,
		MatSnackBarModule,
	],
	providers: [],
	exports: [
		MatExtendedSelectComponent,
		MatStatusIndicatorComponent,
		MatNumberSpinnerComponent,
		WorkdaysComponent,
		LegacyFileUploadComponent,
		FileUploadSinglerDirective,
		TpFileUploadComponent,
		FileUploadCustomSlotDirective,
		TextDisplayContainerComponent,
		TitleHeaderComponent,
		CheckboxListModule,
		WhoYouComponent,
	],
})
export class SharedUIMaterialModule {}
